
import { AppDispatch, RootState } from '../../store';
import { startLoginUser } from '../../store/auth';

import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from "react-hook-form"
import { Link as RouterLink } from 'react-router-dom';

import { Grid, TextField, Button, Link, CircularProgress, Alert } from '@mui/material';


import { AuthLayout } from '../../layouts';
import { regularExps } from '../../helpers/validators';



type Inputs = {
    email: string,
    password: string,
}

export const ForgotPasswordPage = () => {

    // Usa useSelector para acceder al estado 'status' de tu slice de autenticación
    const { status, errorMessage } = useSelector((state: RootState) => state.auth);

    const isChecking = status === 'checking';

    /* PARA HACER EL LOGIN */
    const dispatch = useDispatch<AppDispatch>();

    const { register, handleSubmit, watch, formState: { errors } } = useForm<Inputs>({
        defaultValues: {
            email: '',
        }
    });

    const onSubmit = (data: Inputs) => {
        dispatch(startLoginUser(data.email, data.password));
    };


 

    return (

        <AuthLayout title="Olvido su contraseña" linkTo="reset-password">
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid
                    container
                    alignItems="center"
                    justifyContent="center"

                >
                    <Grid item xs={12} mb={3}>
                        <TextField
                            variant='standard'
                            label="Correo"
                            type='email'
                            placeholder='ejemplo@correo.com'

                            fullWidth
                            color='secondary'
                            {...register("email", {
                                required: "Este campo es requerido",
                                pattern: {
                                    value: regularExps.email,
                                    message: "Este campo debe ser un correo electrónico válido"
                                }
                            })}

                            error={!!errors.email}
                            helperText={errors.email?.message}
                            InputLabelProps={{
                                shrink: true, // Esto mantiene el label reducido y arriba
                                style: {
                                    fontSize: '1.4rem', // Aumenta el tamaño de la fuente del label
                                    //transform: 'translate(14px, -6px) scale(1)', // Ajusta la posición del label
                                },
                            }}
                            InputProps={{
                                style: {
                                    paddingTop: '8px', // Aumenta el padding superior del input para separarlo del label

                                },
                            }}
                        />
                    </Grid>

                   

                    <Grid item xs={12}>

                        <Grid item
                            mb={2}
                            display={errorMessage ? '' : 'none'}
                        >
                            <Alert severity='error' >
                                {errorMessage}
                            </Alert>
                        </Grid>

                        <Button
                            disabled={isChecking}
                            variant="contained"
                            type="submit"
                            color="secondary"
                            fullWidth
                            sx={{ borderRadius: 2, padding: 1.5 , fontSize: '1.1rem'}}
                        >
                            {isChecking ?
                                <CircularProgress style={{ color: '#CE3197', padding: 10 }} />
                                : 'Resetear contraseña'}
                        </Button>
                    </Grid>

                </Grid>
            </form>

        </AuthLayout >
    )

}
